const _ = "styles-module__container___6-2rE", t = "styles-module__content___XYZf8", e = "styles-module__name___kMfj2", n = "styles-module__price___Y5qip", o = "styles-module__validity_period___QLcv7", i = "styles-module__button_container_mobile___BMEYW", l = "styles-module__container_mobile___T7HBj", c = "styles-module__button_container___XfEwk", s = {
  "gift-card-tile": "styles-module__gift-card-tile___zKrZH",
  container: _,
  "image-container": "styles-module__image-container___Zbq88",
  content: t,
  name: e,
  price: n,
  validity_period: o,
  button_container_mobile: i,
  container_mobile: l,
  button_container: c
};
export {
  c as button_container,
  i as button_container_mobile,
  _ as container,
  l as container_mobile,
  t as content,
  s as default,
  e as name,
  n as price,
  o as validity_period
};
